var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0303 5.00131C13.031 4.44902 12.5839 4.00072 12.0316 4C11.4793 3.99928 11.031 4.44641 11.0303 4.99869L11.0224 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11.0198L11.012 18.9987C11.0112 19.551 11.4584 19.9993 12.0107 20C12.5629 20.0007 13.0112 19.5536 13.012 19.0013L13.0198 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13.0224L13.0303 5.00131Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.99622c9e1d6d40361ef79a1619c6d907.svg";
export { ForwardRef as ReactComponent };